import { movies } from "@/mocks/movies";
import { actors } from "@/mocks/actors";
import { articles } from "@/mocks/articles";

export type Movie = (typeof movies)[number];
export type Actor = (typeof actors)[number];
export type Article = (typeof articles)[number];

export function getMovieById(id: string): Movie | undefined {
  return movies.find((movie) => movie.id === id);
}

export function getActorById(id: string): Actor | undefined {
  return actors.find((actor) => actor.id === id);
}

export function getActorByName(name: string): Actor | undefined {
  return actors.find((actor) => actor.name === name);
}

export function getMoviesForActor(actor: Actor): Movie[] {
  return actor.filmIds
    .map((id) => getMovieById(id))
    .filter((movie): movie is Movie => Boolean(movie));
}

export function getRelatedMovies(movie: Movie, limit = 4): Movie[] {
  return movies
    .filter((item) => item.id !== movie.id)
    .map((item) => ({
      movie: item,
      score: item.tags.filter((tag) => movie.tags.includes(tag)).length,
    }))
    .filter((entry) => entry.score > 0)
    .sort((a, b) => b.score - a.score || b.movie.popularity - a.movie.popularity)
    .slice(0, limit)
    .map((entry) => entry.movie);
}

export function getArticlesByType(type: string): Article[] {
  return articles.filter((article) => article.type === type);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((article) => article.id === id);
}